var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.073,
    height: 15.005,
    viewBox: "0 0 3.988 3.97",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 5,
    rx: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 7,
    height: 9,
    rx: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 0 .001)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 5,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 5,
    rx: 1,
    stroke: "#2d6089",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#a)",
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 0 .001)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 7,
    height: 9,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 7,
    height: 9,
    rx: 1,
    stroke: "#2d6089",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#b)",
    ry: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 5,
    rx: 1,
    stroke: "#2d6089",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#c)",
    ry: 1,
    transform: "matrix(-.26458 0 0 .26458 3.988 2.646)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 7,
    height: 9,
    rx: 1,
    stroke: "#2d6089",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#d)",
    ry: 1,
    transform: "matrix(-.26458 0 0 .26458 3.988 -1.588)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dashboard.cbb437a0.svg";
export { ForwardRef as ReactComponent };